import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import QrCodeScanner from "../../../common/QrCodeScanner";
import { fetchMasterList } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { Row, Col } from "react-bootstrap";
import Constants from "../../../../common/Constants";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";

const StartStopJobCardModal = (props) => {
  // eslint-disable-next-line
  let [edit, setEdit] = useState(false);
  let [qrOpen, setQROpen] = useState(false);
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [deptCode, setDeptCode] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setQROpen(true);
  }, []);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleClick = () => {
    if (deptCode) {
      props.onButtonClick(deptCode, "dept"); // Send input value to parent component
    } else {
      props.onButtonClick(inputValue, "from"); // Send input value to parent component
    }
  };

  let deptList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data
  ); // User Details from Store

  let configuredDeptList = [];

  configuredDeptList = useSelector(
    (state) => state?.common?.data?.multiJobcardSelection
  ); // User Details from Store

  const processedDeptResult =
    configuredDeptList &&
    configuredDeptList.map(({ deptCode, deptName }) => deptCode);

  useEffect(() => {
    if (!deptList) {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deptList]);

  const deptResult =
    deptList &&
    deptList.map(({ deptCode, deptName }) => ({
      deptCode,
      deptName: `${deptCode} - ${deptName}`,
    }));

  const filterDeptList = deptResult?.filter((element) =>
    processedDeptResult?.includes(element.deptCode)
  );

  const { show, onHide, title, pageId } = props;
  return (
    <>
      <Modal
        show={show}
        size="lg"
        className="jobcard-qrscanner-modal"
        onHide={onHide}
        animation={false}
        backdrop="static"
        id={pageId}
      >
        <ModalHeader title={title}></ModalHeader>
        <ModalBody>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "90vh",
            }}
          >
            <div
              style={{
                width: "80%",
                height: "auto",
                border: "2px solid black",
                padding: "10px",
              }}
            >
              {qrOpen && (
                <QrCodeScanner
                  onSuccess={props.handleSuccess}
                  onError={props.handleError}
                  qrbox={{ width: 250, height: 250 }} // Reduced qrbox size
                />
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <form className="manual-jobcard-form">
            <Row>
              <Col xs={4} md={4}>
                <label htmlFor="fname">
                  {t("msg_trasaction.startstop_jobcard.manualJobcard")} :{" "}
                </label>
              </Col>
              <Col xs={6} md={6}>
                <input
                  type="text"
                  id="fname"
                  className="form-control"
                  value={inputValue}
                  autoFocus={true}
                  onChange={handleInputChange}
                  name="fname"
                  placeholder={"Ex: 1234_1_1"}
                />
              </Col>
            </Row>
          </form>

          {props.displayDept && (
            <form className="manual-jobcard-form">
              <Row>
                <Col xs={4} md={4}>
                  <label>
                    {t("msg_master_list.msg_machines.select_department")} :{" "}
                  </label>
                </Col>
                <Col xs={6} md={6}>
                  <DropdownListField
                    id="deptCode"
                    name="deptName"
                    className="dropdownHive w-full rounded-md"
                    data={filterDeptList}
                    value={deptCode}
                    onChange={(value) => {
                      setDeptCode(value?.deptCode);
                    }}
                    placeholder={t(
                      "msg_master_list.msg_machines.select_department"
                    )}
                    autoFocus={true}
                    disabled={!filterDeptList}
                  />
                </Col>
              </Row>
            </form>
          )}
          <Row>
            <Col xs={12} md={12}>
              <Button
                type="button"
                variant="success"
                className="btn btn-success"
                onClick={handleClick}
              >
                {"SUBMIT"}
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default StartStopJobCardModal;
